import { createSelector } from 'reselect';
import { selectAllQueryParams } from '../../selectors/routing';

export default createSelector(
  [selectAllQueryParams(['domain_name'])],
  ([domainName]) => ({ domainName }),
);
